export default {
    lang: {
        name: 'First played all-time'
    }
}